import { useTranslation } from 'react-i18next'

import {
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Skeleton,
  Stack,
  Switch,
  Typography,
  useTheme
} from '@mui/material'
import { AuroraHeatPumpStatus } from '../enums'

export interface AuroraHeatPumpStatusControlProps {
  value: AuroraHeatPumpStatus
  loading?: boolean
  onSubmit: (value: AuroraHeatPumpStatus) => Promise<void>
}

export default function AuroraHeatPumpStatusControl({
  value,
  loading = false,
  onSubmit
}: AuroraHeatPumpStatusControlProps) {
  const { t } = useTranslation('aurora')

  const theme = useTheme()

  const isChecked = value === AuroraHeatPumpStatus.ON

  async function handleChange(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    try {
      await onSubmit(checked ? AuroraHeatPumpStatus.ON : AuroraHeatPumpStatus.OFF)
    } catch {
      // Ignore the error.
    }
  }

  return (
    <FormGroup
      sx={{
        p: 4,
        pl: 2,
        borderRadius: 2,
        background: theme.palette.background.default
      }}
    >
      <FormControlLabel
        value="bottom"
        control={
          <>
            {loading ? (
              <CircularProgress size={24} sx={{ mr: 4 }} />
            ) : (
              <Switch color="success" checked={isChecked} onChange={handleChange} />
            )}
          </>
        }
        label={
          <Stack direction="column">
            <Typography color="text.secondary">{t('heatPump')}</Typography>
            <Typography color="text.primary" fontWeight={500}>
              {isChecked ? t('on') : t('off')}
            </Typography>
          </Stack>
        }
        labelPlacement="start"
        sx={{
          display: 'flex',
          ml: 2,
          width: '100%',
          color: 'text.secondary',
          justifyContent: 'space-between'
        }}
      />
    </FormGroup>
  )
}
